export default "__VITE_ASSET__BG1QTqn9__"